import loadable from "@loadable/component";

export const Templates = {
	GenericLayout: loadable(() => import("./GenericTemplate")),
};
